import React, { useEffect, useRef } from 'react';
import './TimeMSA.css';

const membros = [
  {
    nome: 'MARCELO S. ANDRADE',
    cargo: 'FUNDADOR & CEO',
    descricao:
      'Respons\u00e1vel pela vis\u00e3o estrat\u00e9gica da empresa, conduz o crescimento da MSA com foco em inova\u00e7\u00e3o, qualidade e resultados para os clientes.',
    foto: '/sobre-nos/image2.avif',
  },
  {
    nome: 'RENATO AGUIAR',
    cargo: 'GERENTE DE PRODU\u00c7\u00c3O',
    descricao:
      'Coordena os processos produtivos, garantindo efici\u00eancia, qualidade e cumprimento dos prazos em cada projeto.',
    foto: '/sobre-nos/image3.avif',
  },
  {
    nome: 'WAGNER CARNIELO',
    cargo: 'GERENTE ADMINISTRATIVO',
    descricao:
      'Gerencia as opera\u00e7\u00f5es administrativas, assegurando organiza\u00e7\u00e3o, controle e suporte para o bom funcionamento da empresa.',
    foto: '/sobre-nos/image4.avif',
  },
];

function TimeMSA() {
  const titleRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('time__animate--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (titleRef.current) observer.observe(titleRef.current);
    cardRefs.current.forEach((el) => { if (el) observer.observe(el); });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="time">
      <div className="time__container">
        <h2
          className="time__title time__animate time__animate--up"
          ref={titleRef}
        >
          Time MSA
        </h2>

        <div className="time__grid">
          {membros.map((membro, i) => (
            <div
              key={membro.nome}
              className="time__card time__animate time__animate--up"
              ref={(el) => (cardRefs.current[i] = el)}
              style={{ transitionDelay: `${i * 0.12}s` }}
            >
              <div className="time__foto">
                {membro.foto ? (
                  <img src={membro.foto} alt={membro.nome} />
                ) : (
                  <div className="time__foto-placeholder" />
                )}
              </div>
              <h3 className="time__nome">{membro.nome}</h3>
              <p className="time__cargo">{membro.cargo}</p>
              <p className="time__desc">{membro.descricao}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TimeMSA;
